export default "__VITE_ASSET__C0zBJjP8__";